import { LandingRewardsRepository } from '@/core/domain/landing-rewards/repositories/landing-rewards.repository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { environment } from '@/env/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LandingRewardsResponse } from '../../core/domain/landing-rewards/models/landing-rewards.model';

@Injectable({
    providedIn: 'root',
})
export class LandingRewardsImplRepository extends LandingRewardsRepository {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }
    override getLandingRewards(): Observable<LandingRewardsResponse> {
        const currentLanguage = this.getLanguageUseCase.execute().language;
        const params = new HttpParams().set(
            'language',
            currentLanguage === 'es' ? 'ES' : 'EN',
        );

        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.landingRewards,
        ].join('/');

        return this.httpClient.get(url, { params });
    }
}
